import React, { Component } from 'react';
import $ from 'jquery';
import './Sync.css';
import ReactGA from 'react-ga';

class Sync extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div id="sync">
      </div>
    );
  }
}

export default Sync;
